import React from 'react'

import { reactular } from '@vendhq/reactular'
import { displayRound } from '../../../filters/display-round'
import { LineItem } from '../../../models/line-item'

interface Props {
  lineItem: LineItem
}

export const LineItemMarkupPercent: React.FC<Props> = ({ lineItem }) => {
  return (
    <div className="vd-field li-cell-actions-field">
      <div className="vd-label">Markup</div>
      <div className="vd-value li-cell-actions-value">
        {displayRound(lineItem.displayMarkupPercent)}%
      </div>
    </div>
  )
}

export const LineItemMarkupPercentComponent = reactular(LineItemMarkupPercent, [
  'lineItem',
])
